import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse} from "@angular/common/http";
import {UnsubscribeOnDestroyAdapter} from "@shared";
import {BehaviorSubject} from "rxjs";
import {DefaultResponse} from "@core/models/Http/DefaultResponse";
import {environment} from "@enviroment/environment";
import {Entity} from "@core/models/Entity";
import {HttpMesageHandlerService} from "@core/service/http-mesage-handler";

@Injectable({
  providedIn: 'root'
})
export class EntityService extends UnsubscribeOnDestroyAdapter {
  isTblLoading = true;
  dataChange: BehaviorSubject<Entity[]> = new BehaviorSubject<Entity[]>([]);

  constructor(
    private httpClient: HttpClient,
    private httpMsgHandler: HttpMesageHandlerService
  ) {
    super();
  }

  get data(): Entity[] {
    return this.dataChange.value;
  }

  /** CRUD METHODS */
  getAllEntities(): void {
    this.subs.sink = this.httpClient.get<DefaultResponse<Entity[]>>(
      `${environment.backend_url}PacientesCatalogo/entidades-federativas`,).subscribe({
      next: (data) => {
        this.isTblLoading = false;
        this.dataChange.next(data.data);
      },
      error: (error: HttpErrorResponse) => {
        this.isTblLoading = false;
        this.httpMsgHandler.handleMsg(error);
      },
    });
  }
}
